import React, { useState } from 'react';
import axios from 'axios';
import { Paper, TableContainer, Table, TableHead, TableRow, TableCell, TableBody } from '@mui/material';
import DoneIcon from '@mui/icons-material/Done';
import CloseIcon from '@mui/icons-material/Close';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import AlertDialog from './AlertDialog';
import ConfirmDialog from './ConfirmDialog';

export default function Projects(props) {
    const [dataAlert, setDataAlert] = useState({ isShow: false, severity: '', title: '', message: '' });
    const [showConfirm, setShowConfirm] = useState({ show: false, id: 0 });
    const removeProject = () => {
        axios.delete(`https://backend-minerva-entity.pathrover.ir/api/project/RemoveProject/${showConfirm.id}`).then(res => {
            setDataAlert({ isShow: true, severity: 'success', title: 'Success', message: 'Project removed successfully.' });
            props.onSubmit();
        });
        setShowConfirm({ ...showConfirm, show: false });
    }
    return (
        <>
            <TableContainer component={Paper} sx={{ maxHeight: 500, mt: '10px' }}>
                <Table stickyHeader sx={{ maxHeight: 440, minWidth: 650 }}>
                    <TableHead>
                        <TableRow>
                            {props.isAdmin && <TableCell sx={{ fontWeight: 'bold' }}>Id</TableCell>}
                            <TableCell sx={{ fontWeight: 'bold' }}>URL</TableCell>
                            <TableCell sx={{ fontWeight: 'bold' }}>ProjectId</TableCell>
                            {props.isAdmin &&
                                <>
                                    <TableCell sx={{ fontWeight: 'bold' }}>Is Fetched?</TableCell>
                                    <TableCell sx={{ fontWeight: 'bold' }}>Action</TableCell>
                                </>
                            }
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {props.projects.map((row) => (
                            <TableRow
                                key={row.id}
                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                {props.isAdmin && <TableCell scope="row">
                                    {row.id}
                                </TableCell>
                                }
                                <TableCell align="left">{row.url}</TableCell>
                                <TableCell align="left">{row.projectId}</TableCell>
                                {props.isAdmin &&
                                    <>
                                        <TableCell align="left">{row.isChecked ? <DoneIcon color="success" /> : <CloseIcon sx={{ color: 'red' }} />}</TableCell>
                                        <TableCell align="left"><DeleteOutlineIcon color="info" onClick={ev => setShowConfirm({ show: true, id: row.id })} /></TableCell>
                                    </>}
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
            <AlertDialog data={dataAlert} onClose={e => setDataAlert({ isShow: false })} />
            <ConfirmDialog open={showConfirm.show} onSubmit={removeProject} onClose={ev => setShowConfirm({ ...showConfirm, show: false })} />
        </>
    );
}